import React, { Component } from 'react'
import { connect } from 'react-redux'
import Multi from '../../components/Multi'
import WhiteBox from '../../components/WhiteBox'
import BorderButton from '../../components/BorderButton'

class UploadModal extends Component {
    state = {
        displayed: false
    }

    constructor(props) {
        super(props)
        this.state = {
            displayed: false
        }
    }

    renderLoading(uploadStatus) {
        return (
            <Multi>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 40
                    }}>
                    <h2>Uploading File</h2>
                </div>
                <div
                    style={{
                        margin: '20px 40px'
                    }}>
                    <div className="progress-bar-wrapper">
                        <div
                            className="progress-bar-progress"
                            style={{
                                width: `${uploadStatus.progress}%`
                            }}
                        />
                    </div>
                </div>
                <p
                    style={{
                        fontSize: 'smaller',
                        color: '#797979',
                        textAlign: 'center'
                    }}>
                    {uploadStatus.progress}% completed
                </p>
            </Multi>
        )
    }

    renderChecking() {
        return (
            <Multi>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 40
                    }}>
                    <img alt="o" src="/img/preloader.svg" style={{ width: 82, height: 82 }} />
                </div>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 40
                    }}>
                    <h2>Checking uploaded file</h2>
                    <p
                        style={{
                            fontSize: 'smaller',
                            color: '#797979'
                        }}>
                        Please wait while we are controlling your file
                    </p>
                </div>
            </Multi>
        )
    }

    renderCompleted(uploadStatus) {
        const success = !uploadStatus.uploadError && uploadStatus.valid
        return (
            <Multi>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 40,
                        color: success ? '#53e69d' : 'crimson'
                    }}>
                    <i className={`fa ${success ? 'fa-check-circle-o' : 'fa-times-circle-o'}`} style={{ fontSize: '93.33px' }} />
                </div>
                <div
                    style={{
                        textAlign: 'center',
                        marginTop: 40
                    }}>
                    <h2>Upload Status</h2>
                    <p
                        style={{
                            fontSize: 'smaller',
                            color: '#797979'
                        }}>
                        {uploadStatus.uploadError
                            ? 'Your file could not be uploaded'
                            : uploadStatus.valid
                            ? 'File queued for import successfully!'
                            : 'Your file cannot be imported'}
                    </p>
                    <div
                        style={{
                            textAlign: 'center',
                            marginTop: 90,
                            display: 'flex',
                            justifyContent: 'center'
                        }}>
                        <BorderButton
                            className="white very-blue-bg very-round"
                            label={uploadStatus.valid ? 'ok' : 'cancel'}
                            onClick={() => {
                                this.props.onConfirm()
                            }}
                        />
                    </div>
                </div>
            </Multi>
        )
    }

    render() {
        const { uploadStatus } = this.props
        if (uploadStatus) {
            const uploadCompleted = uploadStatus.checked || uploadStatus.uploadError
            return this.props.display ? (
                <Multi>
                    <div className="import-license-upload-screen-backdrop" />
                    <div className="import-license-upload-screen-wrapper">
                        <WhiteBox>
                            {uploadStatus.uploading
                                ? this.renderLoading(uploadStatus)
                                : uploadCompleted
                                ? this.renderCompleted(uploadStatus)
                                : this.renderChecking()}
                        </WhiteBox>
                    </div>
                </Multi>
            ) : null
        }
    }
}

export default connect(
    state => ({}),
    {}
)(UploadModal)
